import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
    };
  },
  async getPrestations() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Prestations/`);
      return [null, data];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`ERROR api Activities: ${error}`); // TODO notification system
      return [error];
    }
  },
  async getPrestation(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Prestations/${id}`);
      return [null, data];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`ERROR api Activities: ${error}`); // TODO notification system
      return [error];
    }
  },
  async put(id, prestation) {
    try {
      const json = JSON.stringify(prestation);
      const data = await axios.put(`${this.baseUrl}Prestations/${id}`, json, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data.data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async deletePrestations(prestations) {
    try {
      prestations.forEach(async (element) => {
        this.deletePrestation(element.id);
      });
      return true;
    } catch (error) {
      Errors.onError(error);
      return false;
    }
  },
  async deletePrestation(id) {
    try {
      await axios({
        method: 'DELETE',
        url: `${this.baseUrl}Prestations/${id}`,
        headers: {
          'User-Id': this.userId,
        },
      });
      return true;
    } catch (error) {
      Errors.onWarn(error);
      return false;
    }
  },
};
